import { setExternalHelpers } from "./uikit.helpers/externals.es.js";
import { setupI18nDefault, injectI18n } from "./uikit.i18n.es.js";
import { useScreenSizeStore } from "./uikit.stores/screenSize.es.js";
import localeFR from "./uikit.locales/fr.es.js";
const plugin = {
  install(app, options) {
    if (!options.i18n) {
      setupI18nDefault(app);
    } else {
      options.i18n.global.mergeLocaleMessage("fr", localeFR.fr);
      injectI18n(options.i18n);
    }
    if (options.helpers) {
      setExternalHelpers(options.helpers);
    }
    useScreenSizeStore().startWatching();
  }
};
export {
  plugin as default
};
//# sourceMappingURL=uikit.plugin.es.js.map
